import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  profileImage: "",
  testimonials: [],
};

const testimonialSlice = createSlice({
  name: "testimonial",
  initialState: initialState,
  reducers: {
    setLoading(state, value) {
      state.loading = value.payload;
    },
    setTestimonial(state, value) {
      state.testimonials = value.payload;
    },
    setProfileImage(state, value) {
      state.profileImage = value.payload;
    },
  },
});

export const { setLoading, setTestimonial, setProfileImage } =
  testimonialSlice.actions;
export default testimonialSlice.reducer;
